import { Badge } from '@mdvip/shared/components/ui/badge';
import { useTranslation } from 'react-i18next';
import type { PriorityTag } from '@/lib/member-views/priorityTags';
import { BlankValue } from './BlankValue';

export interface PriorityTagsCellProps {
  tags: readonly PriorityTag[];
}

/** The Priority tags column: one muted badge per tag, in the order given. Labels, not statuses, so all one style. */
export function PriorityTagsCell({ tags }: PriorityTagsCellProps) {
  const { t } = useTranslation('providers');
  if (tags.length === 0) return <BlankValue />;

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <Badge key={tag} variant="muted" size="sm">
          {t(`memberViews.tags.${tag}`)}
        </Badge>
      ))}
    </div>
  );
}
